import { render } from "./TestUCSupplementaryData.vue?vue&type=template&id=7a8b6b33"
import script from "./TestUCSupplementaryData.vue?vue&type=script&lang=js"
export * from "./TestUCSupplementaryData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__